import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['spinner', 'enterButton']

  connect() {
    if (!sessionStorage.getItem('landingVisited')) {
      this.showEnterButton()
    } else {
      this.showSpinner()
      this.timeoutId = setTimeout(() => {
        this.showEnterButton()
        sessionStorage.setItem('landingVisited', 'true')
      }, 1000)
    }
  }

  showSpinner() {
    this.spinnerTarget.classList.remove('hidden')
    this.enterButtonTarget.classList.add('hidden')
  }

  showEnterButton() {
    this.spinnerTarget.classList.add('hidden')
    this.enterButtonTarget.classList.remove('hidden')
  }

  goToHome() {
    if (this.navigating) return
    if (!this.enterButtonTarget.classList.contains('hidden')) {
      this.navigating = true
      Turbo.visit('/home')
    }
  }
}
